export const T = {
  en_GB: {
    notAvailable:
      "Expected value data is not available. Please ensure all goals have been processed.",
    snapshotMissingMessage:
      "Aggregate expected value data needs to be regenerated. Use the Regenerate button above.",
    errorLoading: "Error loading expected value data. Please refresh the page.",
    unavailable: "Expected Value Data Unavailable",
    contactAdvisor: "Please contact your advisor for assistance.",
  },
  nb_NO: {
    notAvailable: "Forventet avkastning er ikke tilgjengelig. Kontroller at alle mål er behandlet.",
    snapshotMissingMessage:
      "Aggregert forventet avkastning må regenereres. Bruk Regenerer-knappen over.",
    errorLoading: "Feil ved lasting av forventet avkastning. Oppdater siden.",
    unavailable: "Forventet avkastning ikke tilgjengelig",
    contactAdvisor: "Kontakt din rådgiver for hjelp.",
  },
} as const;
